'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { warn } from '../../utilities/index.js';
import { ValidationMessage } from '../validation-message/validation-message.js';

/**
 * FieldCounter component, used to display a counter for a form field.
 *
 * @example
 * <Field>
 *   <Input />
 *   <Field.Counter limit={100} under='%d tegn igjen' over='%d tegn for mye' />
 * </Field>
 */
const FieldCounter = forwardRef(function FieldCounter({ limit, under, over, hint, ...rest }, _ref) {
    if (hint)
        warn('hint attribute is deprecated on Field.Counter');
    return (jsx(ValidationMessage, { suppressHydrationWarning // Since <ds-field> adds attributes
        : true, "data-field": 'counter', "data-limit": limit, "data-under": under, "data-over": over, ...rest }));
});

export { FieldCounter };
